import { ProcesarDatosApi } from "../api/ApiFetch";
const controlador = "registro";

export const AgregarUsuario = async (data) => {
    const url = `${controlador}/AgregarUsuario`;
    return await ProcesarDatosApi('POST', url, data);
}